<template>
  <div class="storageDaPing">
    <!-- 头部 -->
    <div class="heard">
        <div class="img">
          <img src="../../../assets/dapingImg/logo.png" alt />
        </div>
      <span class="title">原料进场</span>
      <div class="date">
        <span>{{ nowDate + " " + nowWeek }}</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="con">
      <!-- 左 -->
      <div class="div left">
        <!-- 原料数据-日拉运 -->
        <div class="top div_con">
          <div class="top_left">
            <div class="tiaoti">原料数据</div>
            <div class="wrapper">
              <ul>
                <li>
                  <span>{{this.yuanliaoData.dailyIntake}}</span>
                  <div>日进场量</div>
                </li>
                <li>
                  <span>{{this.yuanliaoData.dailyArrivalTimes}}</span>
                  <div>日进场车次</div>
                </li>
              </ul>
              <ul>
                <li>
                  <span>{{this.yuanliaoData.dailyIntakeTotal}}</span>
                  <div>累计进场量</div>
                </li>
                <li>
                  <span>{{this.yuanliaoData.dailyArrivalTimesTotal}}</span>
                  <div>累计进场车次</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="top_center"></div>
          <div class="top_left">
            <div class="tiaoti">日拉运计划</div>
            <div>
              <div id="yChart" :style="{ width: '22vw', height: '33vh' }"></div>
            </div>
          </div>
        </div>
        <div class="top div_center"></div>
        <!-- 进场波动 -->
        <div class="bottom div_con top_bottom">
          <div class="tiaoti">原料进场量波动</div>
          <el-button-group
            style="float: right; margin-right: 10px; margin-top: 4px"
            v-model="flag"
            class="buttonBTn"
          >
            <el-button @click="seeDay" type="text" :class="[twoFlag ? 'active' : ' ']" >月度</el-button >
            <el-button @click="seeMonth" type="text" :class="[threeFlag ? 'active' : ' ']"  >年度</el-button >
          </el-button-group>
          <div
            id="boDongChart"
            class="boDongChart"
            :style="{ width: '48vw', height: '36vh' }"
          ></div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="div_center"></div>
      <!-- 右 -->
      <div class="div right">
        <!-- 车辆 -->
        <div class="top div_con">
          <div class="tiaoti">车辆统计</div>
          <div class="yuan">
            <ul>
              <li>
                <div>
                  <i>{{ this.cheliangData.vehicleCount }}</i>
                  <br />
                  注册车辆
                </div>
              </li>
              <li>
                <div>
                  <i>{{ this.cheliangData.useVehicleCount }}</i>
                  <br />
                  在用车辆
                </div>
              </li>
              <li>
                <div>
                  <i>{{ this.cheliangData.taskVehicleCount }}</i>
                  <br />
                  在途车辆
                </div>
              </li>
              <li>
                <div>
                  <i>{{ this.cheliangData.freeVehicleCount }}</i>
                  <br />
                  空车车辆
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="top div_center"></div>
        <!-- 车队 -->
        <div class="bottom div_con">
          <div class="tiaoti">车队日拉运情况</div>
          <div
            id="myChart"
            class="myChart"
            :style="{ width: '48vw', height: '40vh' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入
import {
  rawStockData, // 日拉运
  fleetData // 日拉运
} from '@/api/data-center-server'
export default {
  data () {
    return {
      setMap: null,
      flag: 2, // 年月日标识(1:日\2:月\3:年)
      twoFlag: true,
      threeFlag: false,
      yuanliaoData: {},
      cheliangData: {}, // 车辆
      planListData: [], // 2-日拉运计划
      fleetListData: [], // 3-车队拉运量
      nameData: [], // 3-车队拉运量--车队
      jiahuaData: [], // 3-车队拉运量--计划
      layunData: [], // 3-车队拉运量--拉运
      shenyuData: [], // 3-车队拉运量--剩余
      nianData: [], // 4-波动-年
      yueData: [], // 4-波动-月
      nianShijianList: [], // 4-波动-月
      yueShijianList: [], // 4-波动-月
      nianDataList: [], // 4-波动-月
      yueDataList: [], // 4-波动-月
      yidongList: [], // 4-移动点
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '' // 当前星期
    }
  },

  computed: {},
  mounted () {
    this.currentTime()
    this.rawStockDataS() // 1-数据

    console.log(this.flag, 'this.flag')
    this.setMap = setInterval(() => {
      if (this.flag < 3) {
        this.flag = 3
        this.twoFlag = false
        this.threeFlag = true
        this.rawStockDataS() // 1-数据
        this.seeMonth()
      } else if (this.flag >= 3) {
        this.flag = 2
        this.twoFlag = true
        this.threeFlag = false
        this.rawStockDataS() // 1-数据
        this.seeDay()
      }
      //   if (this.flag == 2) {
      //     this.twoFlag = true
      //     this.threeFlag = false
      //     this.rawStockDataS() // 1-数据
      //     this.seeDay()
      //   } else if (this.flag == 3) {
      //     this.twoFlag = false
      //     this.threeFlag = true
      //     this.rawStockDataS() // 1-数据
      //     this.seeMonth()
      //   }
      console.log(this.flag, 'this.flag')
    }, 25000)
  },
  methods: {
    // 点击月度
    seeDay () {
      this.flag = 2
      this.yueShijianList = []
      this.yueDataList = []
      this.yidongList = []
      if (!this.twoFlag) {
        this.twoFlag = true
        this.threeFlag = false
        this.rawStockDataS()
      }
      this.boDng() // 4-波动
    },
    // 点击年度
    seeMonth () {
      this.flag = 3
      this.yueShijianList = []
      this.yueDataList = []
      this.yidongList = []
      if (this.twoFlag) {
        this.threeFlag = true
        this.twoFlag = false
        this.rawStockDataS()
      }
      this.boDng() // 4-波动
    },
    // 1- 数据
    rawStockDataS () {
      rawStockData({
      })
        .then(res => {
          // 1-原料数据
          this.yuanliaoData = res.rowsrock
          // 3-车辆
          this.cheliangData = res.vehicleStatistics
          // 2-拉运计划
          this.planListData = res.transport
          // 4-波动 年+月
          this.nianData = res.yearList
          this.yueData = res.disList
          // 5-车队日拉运
          this.fleetListData = res.steelFleetList
          this.planDataS() // 2-日拉运
          this.fleetDataS()// 3-车队拉运量
          // 处理波动-月度数据
          let index1 = ''
          let data1 = {}
          let a = []
          if (this.flag == 2) {
            this.yueData.forEach((item, index) => {
              // index1 = item.productTime.indexOf('-')
              // item.productTime = item.productTime.substring(0, index1)
              item.productTime = item.productTime.substring(5)
              this.yueShijianList.unshift(item.productTime)
              this.yueDataList.unshift(item.totalNum)

              // 处理移动点数据
              a.unshift([item.productTime, item.totalNum])
              data1.coords = a
              // data1.coords.push(a)
              this.yidongList = []
              this.yidongList.push(data1)
            })
          } else {
            // 处理波动-年度数据
            this.nianData.forEach((item, index) => {
              this.yueShijianList.unshift(item.totalDate)
              this.yueDataList.unshift(item.transportWeight)

              // 处理移动点数据
              a.unshift([item.totalDate, item.transportWeight])
              data1.coords = a
              // data1.coords.push(a)
              this.yidongList = []
              this.yidongList.push(data1)
            })
          }

          this.boDng() // 4-波动
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2-计划拉运
    planDataS () {
      // this.planListData = res
      let yChart = this.$echarts.init(document.getElementById('yChart'))
      // 绘制图表-圆形
      yChart.setOption({
        tooltip: {
          trigger: 'item',
          show: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // orient: "vertical",
          icon: 'circle',
          top: 'bottom',
          // left: "70%",
          // bottom: "0",
          data: ['计划量', '出港量', '拉运量', '进场量'],
          textStyle: {
            color: '#fff'
          }
        },
        // 设置饼状图每个颜色块的颜色
        color: [ '#03faec', '#5caa29', '#4c87ff', '#ff9e00'],
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '60%'], // 大小
            center: ['50%', '56%'], // 位置
            avoidLabelOverlap: true,
            label: {
              normal: {
                // 设置值域的那指向线
                labelLine: {
                  normal: {
                    show: true // show设置线是否显示，默认为true，可选值：true ¦ false
                  }
                },
                // 饼形图显示格式
                formatter: '{a|{b}：{d}%}\n{hr|}',

                rich: {
                  // 设置百分比数字颜色
                  per: {
                    color: '#00B4FB',
                    fontSize: 14,
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },

            data: [
              { value: this.planListData.plantWeight, name: '计划量' },
              {
                value: this.planListData.clearPortWeight,
                name: '出港量'
              },
              { value: this.planListData.transportWeight, name: '拉运量' },
              { value: this.planListData.inplantWeight, name: '进场量' }
            ]
          }
        ]
      })
    },
    // 3-车队拉运量
    fleetDataS () {
      this.jiahuaData = []
      this.layunData = []
      this.shenyuData = []
      this.nameData = []
      this.fleetListData.forEach((item, index) => {
        this.nameData.push(item.name)
        // 计划吨数
        this.jiahuaData.push(item.planNum)
        // 拉运吨数
        this.layunData.push(item.completeNum)
        // 剩余吨数
        this.shenyuData.push(item.remainNum)
      })
      let myChart = this.$echarts.init(document.getElementById('myChart'))

      // 柱状图数据
      var map4Data1 = this.jiahuaData
      var map4Data2 = this.layunData
      var map4Data3 = this.shenyuData
      // 绘制图表--柱状
      myChart.setOption({
        color: ['#0DD9FE', '#52F23A', '#FFAF03'],
        // backgroundColor: "#323a5e",
        grid: {
          left: '2%',
          right: '4%',
          bottom: '9%',
          top: '25%',
          containLabel: true
        },
        legend: {
          icon: 'circle',
          data: ['日计划量', '日拉运量', '日剩余量'],
          textStyle: {
            color: '#fff'
          }
        },
        // ---  提示框 ----
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: 'item', // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: 'shadow',
            axis: 'auto'
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: {
          type: 'category',

          data: this.nameData,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },

          axisLabel: {
            interval: 0,
            formatter: function (value) {
              var ret = ''// 拼接加\n返回的类目项
              var maxLength = 4// 每项显示文字个数
              var valLength = value.length// X轴类目项的文字个数
              var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
              if (rowN > 1)// 如果类目项的文字大于3,
              {
                for (var i = 0; i < rowN; i++) {
                  var temp = ''// 每次截取的字符串
                  var start = i * maxLength// 开始截取的位置
                  var end = start + maxLength// 结束截取的位置
                  // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                  temp = value.substring(start, end) + '\n'
                  ret += temp // 凭借最终的字符串
                }
                return ret
              } else {
                return value
              }
            },
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          }
        },
        yAxis: {
          type: 'value',
          data: ['2000', '4000', '6000', '8000'],
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        series: [
          {
            name: '日计划量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: map4Data1
          },
          {
            name: '日拉运量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: map4Data2
          },
          {
            name: '日剩余量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: map4Data3
          }
        ]
      })
    },
    // 4-波动
    boDng () {
      let _this = this
      let boDongChart = _this.$echarts.init(
        document.getElementById('boDongChart')
      )

      // 数据
      // 数据
      var XName = this.yueShijianList
      var data1 = this.yueDataList
      var img = [
        'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAAAsSAAALEgHS3X78AAAEp0lEQVR42u3cz4sjRRTA8W9Vd3Vn8mMmjj9WQWSRZQ+CsH+B7MnDIgiCd0E8CYJ/gOAIelo8ehUP/gF6WLw5/gMueFP2sIcF0dHd2Z1kknR11fOQZJJJMtlZd03H7HtQpNOTnpn+8Lrm1etmjIig8e/DKoECKqACKqCGAiqgAiqghgIqoAIqoIYCKqACKqCGAiqgAiqghgIqoAJudKTr+osZMNPvBUQBHwHsPF9fB9R0DeHMOQ6T6WOrhEzXBM4swDOL0M6CrArRVoq3t2dGUIb9fTvatg8ZZup1PDBgzPmy98mey6qfzjLz2WaWjEUZKEvGyi9nWyneMOvGIyFQo2Sbg4MUSChpU9IeTTUpJdsEajPZOJeJG5uBZj7rLLduWS5dGm6XNLEELOFUFj54ACJCaychkpDSASK3bwsXL0YgVpWJKwM0iy9Zy8HdGru7jvt3Pbu7w0wES7drTwAbjTHMGCsQcIAnYTC1/wRx0wEnl27JNgZI8HQ6Kc1mQq83RNzaMjPzXqDbjTQaJRFLxIyyMSxAXEkWrhrQzAAmo5HOjCQf7jflILxOkohL+aUPgV4vEGNJo+E5PAy02+UIMEwBxo0CPDP7Dg5SnEtpt1PA0e87XO25FOoh8IYIH2Y5b45RzGAQBiIltZoHxqMcjbksXAVgdc2EQMYzzzdotyeZWKuleULXJtwT4SODfC2QCWR+IF9KnjuX1Xbo99Op7LVE8iXlz0YBTk5SyLEEjo5OLuccEoFUvHfO+reuUPx4zftXAIcx1hdcF+/TvFab4A0Bs0VwqyhpVnkJT89/Q4DDQ0e77YCMwIUsFMeFZD856699URRvX4nxE4A/jbnxXp7v4Zw3ReGNSDHI8wFQjIafuoyn58L/fB6sth/Ybg9fez2TRC6QZcZYvgHsazF+MP7YCyLXcM7gvSXLDGBqYDg+NhwdmSpPoTrAkub0W+f4FSB1fDucIunMHSLpO8WAH0rSy8u+19MBCHB4OHzd2pI+CEUhpigEiN+l6WcdY252jLn5s7Wf472ImPcN8pUl/tEHoV4XWq1Ke4KrLmPsTA3oODpytFoOyJKSyzHyMSIxteWngMW5cSEdDJQUhTdZVgxOz3/+jFJm4+bA2e5JpNU6WZ4Fw99JwnWMKccwpeddP+B7GZTNUPKqybJy0O+Hs1YfMz9swwvpB8fbGDG0GuGkkK7V0hxSmZQpABI8l2z0v3sJf50qpAMJCd2qCulql3LD1lRGQjm7lEsDz0rkxTQOfiPPxUBcuJTbbhss/Y1eyi3NwsmKInmkZsKk5gtPUzNhvp11507CSy/X6XYStpvFudpZw1ZWIOF4Cq6SdtbKbioJyAhRTu3u9yMJXerN+ugvaQQsjcZ8Q3VnZwxlSDhe1lB9GjrSw5b+1avT8+Jw+979nNaOI6U3KpTrWAosxVQmygK4ld8X0ZtK/7eViExD7O1NQPb3T7fsl4/4sBpwYzPwjFbTo95Yl9l9Vd1YN1X/147HebSjary1AHyc5qc+XLQEQx9ve8Kg6xr6hKoCKqACKqCGAiqgAiqghgIqoAIqoIYCKqACKqCGAiqgAiqghgIq4JrHP8fEWV8FMTmOAAAAAElFTkSuQmCC',
        'image://data:image/png;base64,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',
        'image://data:image/png;base64,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',
        'image://data:image/png;base64,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'
      ]

      var data = this.yidongList
      console.log(data, '11111')
      boDongChart.setOption({
        // backgroundColor: '#0e2147',
        // tooltip: { // 提示框组件
        //   trigger: 'item', // 触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
        //   triggerOn: 'mousemove', // 提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
        //   showContent: true // 是否显示提示框浮层
        //   // alwaysShowContent: true, // 是否永远显示提示框内容
        //   // showDelay: 0, // 浮层显示的延迟，单位为 ms
        //   // hideDelay: 100, // 浮层隐藏的延迟，单位为 ms
        //   // enterable: false, // 鼠标是否可进入提示框浮层中
        //   // confine: false, // 是否将 tooltip 框限制在图表的区域内
        //   // transitionDuration: 0.4, // 提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
        //   // position: ['50%', '50%'], // 提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
        //   // formatter: '{b0}: {c0}<br />{b1}: {c1}', // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
        //   // backgroundColor: 'transparent', // 标题背景色
        //   // borderColor: '#ccc', // 边框颜色
        //   // borderWidth: 0, // 边框线宽
        //   // padding: 5, // 图例内边距，单位px  5  [5, 10]  [5,10,5,10]
        //   // textStyle: mytextStyle // 文本样式
        // },

        grid: {
          left: '8%',
          top: '10%',
          bottom: '17%',
          right: '5%'
        },
        legend: {
          type: 'scroll',
          data: '来电量',
          itemWidth: 18,
          itemHeight: 12,
          textStyle: {
            color: '#00ffff',
            fontSize: 14
          }
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            nameTextStyle: {
              color: '#00FFFF'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(135,140,147,0.8)'
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff',
              fontSize: 14

            }
          }
        ],
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#0696f9'
              }
            },
            axisLabel: {
              inside: false,
              interval: 0,
              rotate: 40,
              textStyle: {
                color: '#fff', // x轴颜色
                // fontWeight: 'normal',
                fontSize: '10',
                lineHeight: 20
              }
            },
            data: XName
          }
        ],
        series: [
          {
            symbolSize: 150,
            symbol: img[2],
            name: '',
            type: 'line',
            data: data1,
            itemStyle: {
              normal: {
                borderWidth: 5,
                color: '#0696f9'
              }
            }
          },
          {
            name: '滑行的光点',
            type: 'lines',
            coordinateSystem: 'cartesian2d',
            symbolSize: 50,
            polyline: true,
            effect: {
              show: true,
              trailLength: 0,
              // symbol: 'arrow',
              period: 50, // 光点滑动速度
              symbolSize: 250,
              symbol: img[0]
            },
            lineStyle: {
              normal: {
                width: 1,
                opacity: 0.6,
                curveness: 0.2
              }
            },
            data: data
          }
        ]
      })
    },
    // 右侧时间
    currentTime () {
      setInterval(this.getDate, 500)
    },
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  },
  // 销毁定时器
  beforeDestroy: function () {
    if (this.setMap) {
      clearInterval(this.setMap) // 在Vue实例销毁前，清除时间定时器
    }
  }
}
</script>

<style lang='less' scoped>
.active {
  color: #00fcf9;
  font-weight: 700;
}
.el-button-group {
  // position: absolute;
  // right: 5vmax;
  // top: 1vh;
  font-size: 18px;
}
button {
  margin-right: 20px;
}
.el-button-group > .el-button:not(:last-child) {
  margin-right: 35px;
}
.storageDaPing {
  width: 100%;
  height: 100vh;
  // display: flex;
  overflow: hidden;
  background: url("../../../assets/dapingImg/bg.png") 100%;
  .heard {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    display: flex;
    background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    .title {
      flex: 1;
      font-size: 30px;
      font-weight: 700;
      color: #03faec;
    }
    .date {
      font-size: 16px;
      color: #ffdd17;
    }
    .img {
      height: 6vh;
      // position: absolute;
      z-index: 1111;
      img {
        height: 100%;
      }
    }
  }
  .con {
    width: 100%;
    height: 92vh;
    margin-top: 1vh;
    padding: 20px;
    display: flex;
    box-sizing: border-box;
    .div_center {
      height: 92vh;
      width: 20px;
    }
    .div {
      flex: 1;
    }
    .left {
      height: 100%;
      display: flex;
      width: 100%;
      flex-direction: column;
      .div_con {
        flex: 1;
        overflow: hidden;
      }
      .div_center {
        height: 20px;
        width: 100%;
      }
      .top {
        display: flex;
        .top_left {
          flex: 1;
          overflow: hidden;
          border: 1px solid #3bfff280;
          background-color: #3bfff215;
          ul {
            display: flex;
            li {
              width: 50%;
              text-align: center;
            }
          }
        }
        .top_center {
          height: 100%;
          width: 20px;
        }
      }
      .top_bottom {
        border: 1px solid #3bfff280;
        background-color: #3bfff215;
      }
    }
    .right {
      height: 100%;
      display: flex;
      flex-direction: column;
      width: 100%;
      .div_con {
        flex: 1;
        overflow: hidden;

        border: 1px solid #3bfff280;
        background-color: #3bfff215;
      }
      .div_center {
        height: 20px;
        width: 100%;
      }
    }
    .wrapper {
      ul {
        display: flex;
        li {
          flex: 1;
          height: 14vh;
          padding-top: 40px;
          // line-height: 16vh;
         span {
          color: #03faec;
          font-size: 22px;
        }
        div {
          color: #fff;
          font-size: 12px;
        }
        }
      }
    }
    .yuan {
      height: 35vh;
      display: flex;
      ul {
        width: 100%;
        flex: 1;
        height: 35vh;
        text-align: center;
        // padding-top: 3vh;
        box-sizing: border-box;
        display: flex;
        margin: 0;
        padding: 0;
        // margin: 2vh;
        li {
          width: 25%;
          margin-top: 5vh;
          // flex: 1;
          padding: 30px;
          text-align: center;
          color: #fff;
          position: relative;
          div {
            width: 18vh;
            height: 18vh;
            padding-top: 6vh;
            box-sizing: border-box;
            border-radius: 9vh;
          }

          i {
            font-size: 25px;
          }
        }
        li:first-child div {
          background-color: #0c5cd9;
        }
        li:nth-child(2) div {
          background-color: #d6940c;
        }
        li:nth-child(3) div {
          background-color: #0eba1a;
        }
        li:nth-child(4) div {
          background-color: #2e9cfd;
        }
      }
    }
  }
  .tiaoti {
    padding-left: 10px;
    height: 4vh;
    line-height: 4vh;
    font-size: 18px;
    font-weight: 700;
    color: #03faec;
    background-color: #3bfff22f;
  }
}
.buttonBTn{
  z-index: 11111;
}
</style>
